export default __webpack_public_path__ + "static/media/AE23.9b17f66a.jpg";